import React from 'react';
import { generateExpWithNum } from '../../../../../utils/generateExpWithNum';
import { declensions } from '../../../../../constants/declensions';
import CellContent from '../../../../common/CellContent/CellContent';
import { generateAddress } from '../../../../../utils/generateAddress';
import { columnKeyMap } from '../../constants/columnKeyMap';
import { houseStagesColorsMap } from '../../../../../constants/stagesColorMaps';
import {
  TableFilterDropdown,
  TableFilterIcon,
} from '../../../../../../../components/tableComponents';
import { HouseRegistrationTypeManager } from '../../../HouseRegistrationTypeManager';
import TypeIcon from '../../../HouseRegistrationTypeManager/components/TypeIcon/TypeIcon';
import ChessIcon from '../../../ChessIcon/ChessIcon';

const {
  houseType,
  address,
  aliveClientCount,
  porchCount,
  flatCount,
  clientCount,
  houseStageName,
  registrationType,
  region,
  existLayout,
} = columnKeyMap;

const fontSizeStyle = {
  fontSize: '18px',
};

export const getHousesTableColumns = ({
  sortedInfo,
  houseStages,
  houseTypes,
  houseRegions,
  filteredInfo,
}) => {
  const hasStageFilter = houseStages.length > 1;
  const hasTypeFilter = houseTypes.length > 1;
  const hasRegionFilter = houseRegions.length > 1;

  return [
    {
      title: 'Вид дома',
      dataIndex: 'type.name',
      key: houseType,
      colSpan: 1,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === houseType && sortedInfo?.order,
      width: '10%',
      filters: hasTypeFilter ? houseTypes : [],
      filteredValue:
        filteredInfo && filteredInfo[houseType]
          ? filteredInfo[houseType]
          : null,
      filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
      filterDropdown: hasTypeFilter
        ? (props) => <TableFilterDropdown {...props} />
        : undefined,
      render: (text) => (
        <CellContent
          contentStyle={fontSizeStyle}
          topRowContent={text}
          isHighlighted
        />
      ),
    },
    {
      title: 'Микрорайон',
      key: region,
      width: '10%',
      colSpan: 1,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === region && sortedInfo?.order,
      filters: hasRegionFilter ? houseRegions : [],
      filteredValue:
        filteredInfo && filteredInfo[region]
          ? filteredInfo[region]
          : null,
      filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
      filterDropdown: hasRegionFilter
        ? (props) => <TableFilterDropdown {...props} />
        : undefined,
      render: (record) =>
        record?.regionName ? (
          <CellContent
            topRowContent={record?.regionName}
            isHighlighted
            contentStyle={fontSizeStyle}
          />
        ) : null,
    },
    {
      title: 'Адрес',
      key: address,
      width: '16%',
      colSpan: 1,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === address && sortedInfo?.order,
      render: (record) => (
        <CellContent
          topRowContent={generateAddress(record)}
          isHighlighted
          contentStyle={fontSizeStyle}
        />
      ),
    },
    {
      title: 'Стадия',
      dataIndex: houseStageName,
      key: houseStageName,
      width: '13%',
      colSpan: 1,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === houseStageName && sortedInfo?.order,
      filters: hasStageFilter ? houseStages : [],
      filteredValue:
        filteredInfo && filteredInfo[houseStageName]
          ? filteredInfo[houseStageName]
          : null,
      filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
      filterDropdown: hasStageFilter
        ? (props) => <TableFilterDropdown {...props} />
        : undefined,
      render: (stageName, record) => {
        if (!stageName) {
          return null;
        }

        return (
          <CellContent
            topRowContent={stageName}
            isHighlighted
            style={{
              backgroundColor: houseStagesColorsMap.get(record.houseStageId),
            }}
            contentStyle={fontSizeStyle}
          />
        );
      },
    },
    {
      title: 'Подъездов',
      dataIndex: porchCount,
      key: porchCount,
      colSpan: 1,
      width: '11%',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === porchCount && sortedInfo?.order,
      render: (num) => (
        <CellContent contentStyle={fontSizeStyle} topRowContent={num ?? '-'} />
      ),
    },
    {
      title: 'Квартир',
      dataIndex: flatCount,
      key: flatCount,
      colSpan: 1,
      width: '10%',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === flatCount && sortedInfo?.order,
      render: (num) => (
        <CellContent contentStyle={fontSizeStyle} topRowContent={num ?? '-'} />
      ),
    },
    {
      title: 'Жильцов',
      dataIndex: clientCount,
      key: clientCount,
      colSpan: 1,
      width: '10%',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === clientCount && sortedInfo?.order,
      render: (num) => (
        <CellContent contentStyle={fontSizeStyle} topRowContent={num ?? '-'} />
      ),
    },
    {
      title: 'С МП',
      dataIndex: aliveClientCount,
      key: aliveClientCount,
      colSpan: 1,
      width: '10%',
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === aliveClientCount && sortedInfo?.order,
      render: (num) => (
        <CellContent
          contentStyle={fontSizeStyle}
          topRowContent={generateExpWithNum(num, declensions.residents)}
        />
      ),
    },
    {
      title: 'Регистрация',
      dataIndex: 'registrationType.id',
      key: registrationType,
      colSpan: 1,
      width: '7%',
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === registrationType && sortedInfo?.order,
      render: (_text, record) => {
        return <TypeIcon type={record.registrationType} houseData={record} />;
      },
    },
    {
      title: 'Шахматка',
      dataIndex: existLayout,
      key: existLayout,
      colSpan: 1,
      width: '7%',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === existLayout && sortedInfo?.order,
      render: (existLayout) => {
        return <ChessIcon existLayout={existLayout} />;
      },
    },
    {
      title: '',
      key: 'TemplatePopover',
      colSpan: 1,
      width: '3%',
      render: (_text, record) => {
        return <HouseRegistrationTypeManager houseData={record} />;
      },
    },
  ];
};
